import TypographyParagraph from '../typography/TypographyParagraph'
import FileIcon from '../icons/Miscellaneous/FileIcon'
import TypographyLabel from '../typography/TypographyLabel'
import { OpenInNewIcon } from '../icons'
import { Button } from '../buttons'
import { MediaAttestationVideo } from '../content/Video'
import Image from '../content/Image'
import Audio from '../content/Audio'

const Media = ({
	metadata,
	isPreview,
}: {
	metadata: any
	isPreview?: boolean
}) => {
	return (
		<div className="mr-8 flex flex-col">
			{metadata.properties.title && (
				<div>
					<TypographyParagraph
						size="medium"
						isBold={true}
						additionalClasses="mb-1 text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{metadata.properties.title}
					</TypographyParagraph>
				</div>
			)}
			{metadata.properties.description && (
				<div>
					<TypographyParagraph
						size="medium"
						additionalClasses="mb-1 text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{metadata.properties.description}
					</TypographyParagraph>
				</div>
			)}
			<div className="mt-4 h-auto w-full">
				{/* video */}
				{metadata.properties.fileType === 'video' ? (
					<MediaAttestationVideo
						videoUrl={metadata.properties.web2URL}
						title={
							metadata.properties.title
								? metadata.properties.title
								: metadata.properties.fileName
						}
					/>
				) : null}
				{/* image */}
				{metadata.properties.fileType === 'image' ? (
					<Image
						className="h-auto w-full rounded-lg object-contain"
						imageUrl={metadata.properties.web2URL}
						imageAlt={
							metadata.properties.title
								? metadata.properties.title
								: metadata.properties.fileName
						}
					></Image>
				) : null}
				{/* audio */}
				{metadata.properties.fileType === 'audio' ? (
					<Audio
						className="h-12 w-full"
						containerClassName="w-full"
						audioURL={metadata.properties.web2URL}
					/>
				) : null}
				{/* pdf */}
				{metadata.properties.fileExtension === 'pdf' ? (
					<div
						className={
							'group flex w-full rounded-md border border-textInactiveLight p-2 dark:border-textInactiveDark'
						}
					>
						<div
							className={
								'mr-2 flex h-20 w-20 items-center justify-center bg-uiPrimaryLight dark:bg-uiPrimaryDark'
							}
						>
							<span className={'relative inline-block'}>
								<FileIcon />
							</span>
						</div>
						<div
							className={
								'mx-2 flex flex-grow flex-col justify-center gap-y-1 overflow-x-auto'
							}
						>
							<div className="flex items-center gap-x-1 text-textPrimaryLight dark:text-textPrimaryDark">
								<TypographyLabel
									size="medium"
									isBold={true}
									additionalClasses={
										'text-textPrimaryLight dark:text-textPrimaryDark text-left'
									}
								>
									{metadata.properties.fileName}
								</TypographyLabel>
							</div>
							<TypographyLabel
								size="small"
								additionalClasses={
									'mr-3 text-labelSmallSemiBold text-textSecondaryLight dark:text-textSecondaryDark truncate text-left'
								}
							>
								{metadata.properties.pageCount} Pages •{' '}
								{metadata.properties.fileSize}
							</TypographyLabel>
						</div>
						<div
							className={
								'flex flex-grow items-center justify-end text-grey500 group-hover:text-grey800 dark:text-grey400 dark:group-hover:text-white'
							}
						>
							<Button
								leftIcon={<OpenInNewIcon />}
								variant="primary"
								size="xSmall"
								onClick={() => {
									window.open(metadata.properties.web2URL, '_blank')
								}}
							>
								View PDF
							</Button>
						</div>
					</div>
				) : null}
				{isPreview &&
				metadata.properties.fileExtension &&
				metadata.properties.fileSize &&
				metadata.properties.fileExtension !== 'pdf' ? (
					<TypographyLabel
						size="small"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark mt-4"
					>
						{metadata.properties.fileExtension} • {metadata.properties.fileSize}
					</TypographyLabel>
				) : null}
			</div>
		</div>
	)
}

export default Media
